import { Trash01Icon } from '@langchain/untitled-ui-icons';
import { Input } from '@mui/joy';

const INPUT_SX = {
  background: 'transparent',
  p: 1.5,
  px: 2,
  borderRadius: 0,
  fontFamily: "'Fira Code', monospace",
  lineHeight: '1em',
  minHeight: 'auto',
  border: 'none',
  ':before': { content: 'none' },
} as const;

export interface ToolEditorProps {
  name: string;
  onChangeName: (name: string) => void;
  id: string;
  onChangeId: (id: string) => void;
  onDelete?: () => void;
}

export function ToolEditor(props: ToolEditorProps) {
  return (
    <div className="flex items-center justify-between gap-2">
      <div className="flex flex-wrap items-center">
        <Input
          placeholder="Tool name"
          className="font-mono"
          sx={{ ...INPUT_SX, width: '150px' }}
          value={props.name ?? ''}
          onChange={(e) => props.onChangeName(e.target.value)}
        />
        <Input
          placeholder="Tool call ID"
          className="font-mono"
          sx={{
            ...INPUT_SX,
            width: '150px',
            color: 'gray',
            '&:hover': {
              color: 'gray',
            },
          }}
          value={props.id ?? ''}
          onChange={(e) => props.onChangeId(e.target.value)}
        />
      </div>

      {props.onDelete && (
        <button
          type="button"
          className="mr-4 flex items-center justify-center rounded-md border border-secondary p-1 opacity-0 transition-all focus-within:opacity-100 group-hover:opacity-100"
          onClick={props.onDelete}
        >
          <Trash01Icon className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
